import { cn } from '@/lib/utils';

interface PriorityBadgeProps {
  priority?: string;
  className?: string;
}

const priorityConfig = {
  'SEV-1': {
    label: 'SEV-1',
    bgColor: 'bg-red-600',
    textColor: 'text-white',
    borderColor: 'border-red-600',
  },
  'SEV-2': {
    label: 'SEV-2',
    bgColor: 'bg-orange-500',
    textColor: 'text-white',
    borderColor: 'border-orange-500',
  },
  'SEV-3': {
    label: 'SEV-3',
    bgColor: 'bg-yellow-500',
    textColor: 'text-white',
    borderColor: 'border-yellow-500',
  },
  'SEV-4': {
    label: 'SEV-4',
    bgColor: 'bg-blue-500',
    textColor: 'text-white',
    borderColor: 'border-blue-500',
  },
  'SEV-5': {
    label: 'SEV-5',
    bgColor: 'bg-gray-500',
    textColor: 'text-white',
    borderColor: 'border-gray-500',
  },
} as const;

// Custom priority fallback colors
const getCustomPriorityConfig = (priority: string) => ({
  label: priority,
  bgColor: 'bg-purple-500',
  textColor: 'text-white',
  borderColor: 'border-purple-500',
});

export const PriorityBadge = ({
  priority,
  className,
}: PriorityBadgeProps): JSX.Element | null => {
  // Don't render if priority is undefined or empty
  if (priority === undefined || priority === '') {
    return null;
  }

  // Use predefined config for SEV-1 to SEV-5, otherwise use custom config
  const config =
    priority in priorityConfig
      ? priorityConfig[priority as keyof typeof priorityConfig]
      : getCustomPriorityConfig(priority);

  return (
    <div
      className={cn(
        'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border',
        config.bgColor,
        config.textColor,
        config.borderColor,
        className,
      )}
    >
      {config.label}
    </div>
  );
};

// Keep the old export for backward compatibility
export const SeverityBadge = PriorityBadge;
